import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../../api/axios";
import { ArrowLeft, Save } from "lucide-react";
import { toast } from "react-toastify";

function EditActive() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    model: "",
    serial_number: "",
    brand: "",
    quantity: 1,
    state: "",
    observation: "",
    active_category_id: "",
    active_location_id: "",
    active_area_id: "",
  });
  const [categories, setCategories] = useState([]);
  const [locations, setLocations] = useState([]);
  const [areas, setAreas] = useState([]);

  useEffect(() => {
    fetchActive();
    fetchCategories();
    fetchLocations();
    fetchAreas();
  }, []);

  const fetchActive = async () => {
    try {
      const res = await api.get(`/actives/${id}`);
      setFormData(res.data);
    } catch (error) {
      toast.error("Error al cargar activo");
    }
  };

  const fetchCategories = async () => {
    const res = await api.get("/active-categories");
    setCategories(res.data);
  };

  const fetchLocations = async () => {
    const res = await api.get("/active-locations");
    setLocations(res.data);
  };

  const fetchAreas = async () => {
    try {
      const res = await api.get("/active-areas");
      setAreas(res.data);
    } catch (error) {
      toast.error("Error al cargar áreas");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/actives/${id}`, formData);
      toast.success("Activo actualizado correctamente");
      navigate("/actives");
    } catch (error) {
      toast.error("Error al actualizar activo");
    }
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow-md max-w-xl mx-auto">
      <button
        onClick={() => navigate("/actives")}
        className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-6"
      >
        <ArrowLeft size={20} />
        Volver a activos
      </button>

      <h2 className="text-3xl font-semibold text-gray-800 mb-6">Editar Activo</h2>

      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Modelo</label>
          <input
            type="text"
            name="model"
            value={formData.model}
            onChange={handleChange}
            placeholder="Ej: Dell XPS 13"
            required
            className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Número de Serie</label>
          <input
            type="text"
            name="serial_number"
            value={formData.serial_number}
            onChange={handleChange}
            placeholder="Ej: SN123456789"
            required
            className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Marca</label>
            <input
              type="text"
              name="brand"
              value={formData.brand}
              onChange={handleChange}
              placeholder="Ej: Lenovo"
              className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Cantidad</label>
            <input
              type="number"
              name="quantity"
              value={formData.quantity}
              onChange={handleChange}
              min={1}
              className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Estado
          </label>
          <select
            name="state"
            value={formData.state || ""}
            onChange={handleChange}
            className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Seleccionar estado</option>
            <option value="En Uso">En uso</option>
            <option value="Disponible">Disponible</option>
            <option value="Reparación">Reparación</option>
          </select>
        </div>


        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Observación</label>
          <textarea
            name="observation"
            value={formData.observation}
            onChange={handleChange}
            placeholder="Cualquier detalle adicional"
            className="w-full border border-gray-300 px-4 py-2 rounded-lg h-28 resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="grid grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Categoría</label>
            <select
              name="active_category_id"
              value={formData.active_category_id}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Seleccionar categoría</option>
              {categories.map((cat) => (
                <option key={cat.id} value={cat.id}>
                  {cat.name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Ubicación</label>
            <select
              name="active_location_id"
              value={formData.active_location_id}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Seleccionar ubicación</option>
              {locations.map((loc) => (
                <option key={loc.id} value={loc.id}>
                  {loc.name}
                </option>
              ))}
            </select>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Área
            </label>

            <select
              name="active_area_id"
              value={formData.active_area_id || ""}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Seleccionar área</option>

              {areas.map((area) => (
                <option key={area.id} value={area.id}>
                  {area.name}
                </option>
              ))}
            </select>
          </div>
        </div>


        <div className="flex">
          <button
            type="submit"
            className="flex items-center gap-2 bg-yellow-500 hover:bg-yellow-600 text-white px-5 py-2 rounded-lg shadow transition duration-300"
          >
            <Save size={18} />
            Guardar Cambios
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditActive;
